module.exports = __webpack_public_path__ + "static/media/icono_imitador.0ba19397.svg";